import {useMemo} from 'react';
import {createGetOneHook} from '@/utils/createGetOneHook';
import {createFieldsHook} from '@/utils/createFieldsHook';
import ClientsAreaApiService from '@/modules/clients/services/ClientsAreaApiService';
import {CACHE_KEY_CLIENTS_AREA} from '@/modules/clients/contants/clientAreas';
import {fields} from '@/modules/clients/contants/clientAreas.form';
import {useQuery} from 'react-query';
import {TermFilter} from '@dofleini/query-builder';

export const useGetOneArea = createGetOneHook(ClientsAreaApiService, 'id', CACHE_KEY_CLIENTS_AREA);
export const useFields = createFieldsHook('clientsArea', fields);

export const useGetOne = (areaId, isLaunched = true) => {
  const queryConfig = useMemo(() => {
    return {enabled: !!(areaId && isLaunched)};
  }, [areaId, isLaunched]);

  const {isLoading, isError, error, data} = useQuery([CACHE_KEY_CLIENTS_AREA, areaId], async () => {
    const {data} = await ClientsAreaApiService.getOneArea({areaId});
    return data;
  }, queryConfig);
  return {isLoading, isError, error, data};
};


export const useGetAllFacilities = (establishments, isLaunching = true, additionalParams) => {
  const queryConfig = useMemo(() => {
    return {enabled: !!(establishments?.length && isLaunching)};
  }, [establishments?.length, isLaunching]);

  const filters = useMemo(() => {
    if (establishments?.length && establishments?.[0] !== 'all')
      return new TermFilter({ field: 'establishment', value: { $in: establishments } });
    return null;
  }, [establishments]);

  const {isLoading, isError, error, data} = useQuery([CACHE_KEY_CLIENTS_AREA, filters], async () => {
    const {data} = await ClientsAreaApiService.search({filters, ...additionalParams});
    return data;
  }, queryConfig);
  return {isLoading, isError, error, data};
};

export const useGetAllAreas = (filters, params) => {
  const queryConfig = useMemo(() => {
    return {enabled: !!(filters)};
  }, [filters]);

  const {data, isLoading} = useQuery(['CACHE_KEY_LIST_ESTABLISHMENTS', filters], async () => {
    const {data} = await ClientsAreaApiService.search({filters, ...params});
    return data;
  }, queryConfig);
  return {isLoading, data};
};

export const useGetAllFacilitiesUser = (filters, params) => {
  const queryConfig = useMemo(() => {
    return {enabled: !!(filters)};
  }, [filters]);

  const {data, isLoading} = useQuery(['CACHE_KEY_LIST_AREAS_USER', filters], async () => {
    const {data} = await ClientsAreaApiService.searchSpace({filters, ...params});
    return data;
  }, queryConfig);
  return {isLoading, data};
};
